import { useState } from 'react';

export const useAnimation = () => {
  const [start, setStart] = useState(false);

  const startAnimation = () => {
    setStart(true);
    setTimeout(() => setStart(false), 1000);
  };

  const validateAnimationStyles = {
    position: 'relative',
    bottom: '0px',
    animationName: 'validation',
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationPlayState: start ? 'running' : 'paused',

    '@keyframes validation': {
      '0%': {
        bottom: '0px'
      },
      '80%': {
        bottom: '12px'
      },
      '100%': {
        bottom: '0px'
      }
    }
  };

  return [startAnimation, validateAnimationStyles];
};
